import { get } from '@dimjs/utils';
import { type WebviewJavascriptBridgeApi } from '../type.api.js';

/**
 * Native内置接口, 判断指定调用的接口是否存在.
 * @param name 接口名称
 */
export const ntvHasMethod: WebviewJavascriptBridgeApi['ntvHasMethod'] = (
  name: string
): boolean => {
  const methodFn = window[name] || get(window as object, name);
  return methodFn && typeof methodFn === 'function';
};
